export default class Link {
    constructor(element, w) {
        this.window = w || window;
        this.$element = $(element);
        this.url = this.$element.data('link');
        this.target = this.$element.data('link-target') || 'self';
    }

    click() {
        if (this.$element.data('link')) {
            this.window.open(this.url, `_${this.target}`);
        }
    }

    setListeners() {
        this.$element
            .off('click', '', $.proxy(this, 'click'))
            .on('click', $.proxy(this, 'click'));
    }

    init() {
        this.setListeners();
    }
}
